import styled, { css } from 'styled-components';
import { BaSeTheme } from '@base/react';

const brkp = BaSeTheme.breakpoints.tablet.maxWidth;

export const MainBody = styled.div`
  background-color: #ffffff;
  box-shadow: 0px 2px 4px rgba(20, 46, 82, 0.2);
  border-radius: 8px;
  margin-top: ${({ broken }) => (broken ? '0px' : '6px')};
`;

export const CardHeader = styled.div`
  padding: 12px 12px 8px 24px;
  display: flex;
  gap: 10px;
  align-items: center;
  border-bottom: 1px solid #e0e6eb;
  justify-content: space-between;

  @media screen and (max-width: ${brkp}px) {
    padding: 10px 18px 10px 24px;
  }
`;

export const CardHeaderButtons = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const CardContentWrapper = styled.div`
  position: relative;
  display: flex;
  overflow: hidden;
`;

export const CardLeftPanel = styled.div`
  ${({ isOpen }) => css`
    width: 100%;
    max-width: 237px;
    min-width: 237px;
    box-sizing: border-box;
    border-right: 1px solid #e0e6eb;
    box-shadow: 8px 0px 12px -7px rgba(20, 46, 82, 0.2);
    z-index: 5;
    position: relative;
    transition: ${BaSeTheme.transitions.allPropertiesContinuousSlow};
    @media screen and (max-width: ${brkp}px) {
      max-width: 154px;
      min-width: 154px;
      ${!isOpen &&
      css`
        position: absolute;
        left: -134px;
      `}
    }
  `}
`;

export const CardRightPanel = styled.div`
  overflow-x: scroll;
  position: relative;
  background-color: #f0f6fe;

  ::-webkit-scrollbar {
    height: 8px;
  }
`;

export const LeftInfoMain = styled.div`
  ${({ blue, last, height, hasClick, hide }) => css`
    padding: 0 16px 0 24px;
    background-color: ${blue ? '#F0F6FE' : '#fff'};
    border-bottom: 1px solid #e0e6eb;
    height: ${height};
    display: flex;
    align-items: center;
    gap: 10px;
    box-sizing: border-box;
    transition: ${BaSeTheme.transitions.allPropertiesContinuousSlow};
    position: relative;
    ${last &&
    css`
      border-bottom: none;
      border-bottom-left-radius: 8px;
    `}
    ${hasClick &&
    css`
      cursor: pointer;
    `}
    ${hide &&
    css`
      display: none;
      width: 0;
      height: 0;
      opacity: 0;
    `}
    @media screen and (max-width: ${brkp}px) {
      background-color: ${blue
        ? BaSeTheme.colors.institucionais.cinzaSebrae97
        : '#fff'};
    }

    small {
      white-space: nowrap;
    }
  `}
`;

export const RightInfoMain = styled.div`
  ${({ blue, height, hide }) => css`
    background-color: ${blue ? '#F0F6FE' : '#fff'};
    display: flex;
    align-items: center;
    height: ${height};
    transition: ${BaSeTheme.transitions.allPropertiesContinuousSlow};

    @media screen and (max-width: ${brkp}px) {
      background-color: ${blue
        ? BaSeTheme.colors.institucionais.cinzaSebrae97
        : '#fff'};
    }
    ${hide &&
    css`
      display: none;
      width: 0;
      height: 0;
      opacity: 0;
    `}
  `}
`;

export const RightInfoCell = styled.div`
  ${({ height, blue, noBorder, last }) => css`
    border-bottom: ${noBorder ? 'none' : '1px solid #e0e6eb'};
    background-color: ${blue ? '#F0F6FE' : '#fff'};
    height: ${height};
    display: grid;
    place-items: center;
    box-sizing: border-box;
    @media screen and (max-width: ${brkp}px) {
      background-color: ${blue
        ? BaSeTheme.colors.institucionais.cinzaSebrae97
        : '#fff'};
    }
    ${last &&
    css`
      padding-top: 4px;
    `}
  `}
`;

export const RightCellContent = styled.div`
  width: 150px;
  display: flex;
  justify-content: center;
`;

export const LeftButtonToggler = styled.div`
  position: absolute;
  right: -15px;
  top: 7px;
`;

export const ExternalShell = styled.div`
  display: flex;
  gap: 8px;
  flex-flow: column;
`;
